// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

const RENDER_COUNT=5; // Num pages to render at a time
const CHUNK_SIZE=10; // Num pages to request at a time
const STATIC_LOAD_MAX=100;
const ASPECT_RATIO=11/8.5;
const PAGE_MARGIN=40; // Pixels

export { RENDER_COUNT, CHUNK_SIZE, STATIC_LOAD_MAX, ASPECT_RATIO, PAGE_MARGIN };